import React from "react";
import { MuiBox } from "../box/MuiBox";
import { MuiTypography } from "../typography/MuiTypography";
import { TypographyProps } from "@mui/material";
import { IconTextWrapper } from "./IconText.style";

interface IconTextProps {
  icon: React.ReactNode;
  title: string;
  typoVariant?: TypographyProps["variant"];
  iconWidth?: string;
  iconHeight?: string;
}
export const IconText: React.FC<IconTextProps> = React.memo(
  ({ icon, title, typoVariant = "h2SemiBold", iconWidth, iconHeight }) => (
    <IconTextWrapper iconWidth={iconWidth} iconHeight={iconHeight}>
      <MuiBox className="icon-text-wrapper">
        <MuiBox className="icon-box">{icon}</MuiBox>
        <MuiTypography variant={typoVariant}>{title}</MuiTypography>
      </MuiBox>
    </IconTextWrapper>
  ),
);
